export function setCookie(name, value, days = 0) {
  const isHttps = window.location.protocol === "https:";
  let cookieStr =
    `${name}=${encodeURIComponent(value)};` +
    `path=/;` +
    `samesite=lax` +
    (isHttps ? `; secure` : ``);

  if (days > 0) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    cookieStr += `; expires=${date.toUTCString()}`;
  }

  document.cookie = cookieStr;
}

export function getCookie(name) {
  const escaped = name.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
  const match = document.cookie.match(new RegExp(`(?:^|; )${escaped}=([^;]+)`));
  return match ? decodeURIComponent(match[1]) : null;
}

export function deleteCookie(name) {
  document.cookie = `${name}=; Max-Age=0; path=/;`;
}

export function hasAuthCookie() {
  return !!getCookie("auth_token");
}

export function clearAuthCookies() {
  ["auth_token", "auth_user", "office_id"].forEach(deleteCookie);
  try {
    localStorage.removeItem("token");
    localStorage.removeItem("auth_user");
    localStorage.removeItem("office_id");
  } catch {
    // ignore
  }
}

export function applyFullAuthSession(payload) {
  const token = payload?.token || payload?.data?.token || null;
  const user = payload?.data || payload?.user || null;

  if (!token || !user) return false;

  const role = user?.role || user?.type || null;
  const consultantId = user?.consultant?.id || user?.consultant_id || null;
  const officeId =
    user?.office_id ||
    user?.office?.id ||
    user?.data?.office_id ||
    user?.data?.office?.id ||
    null;

  if (role) user.role = role;
  if (consultantId && !user.consultant_id) user.consultant_id = consultantId;
  if (officeId && !user.office_id) user.office_id = officeId;

  setCookie("auth_token", token, 0);
  setCookie("auth_user", JSON.stringify(user), 0);
  if (officeId) setCookie("office_id", String(officeId), 0);

  return true;
}
